import { Divider, Grid, Paper, Tab, Tabs } from '@material-ui/core';
import { useContext, useState } from 'react';
import { Title, useAuthenticated } from 'react-admin';
import { AppContext } from '../../../providers/app-context-provider/app.context';
import { ProfileEnum } from '../../../utils/general-profile.enum';
import { TutorialDialog } from '../../tutorial-dialog';
import TeacherDashboardActivities from './teacher-dashboard-activities.component';
import TeacherDashboardPendingGrades from './teacher-dashboard-pending-grades.component';
import TeacherDashboardProcesses from './teacher-dashboard-processes.component';



const Panel = (props) => {

    const { children, value, index, ...rest } = props;

    return (
        <div hidden={value !== index} {...rest} >
            {children}
        </div>
    )
}

const TeacherDashboard = ({ tutorialComplete, ...props }) => {

    const [val, setVal] = useState(0)

    useAuthenticated()

    const handleTabChange = (event, value) => {
        setVal(value);
    }

    const context = useContext(AppContext)

    return (
        <Grid container spacing={1} style={{ marginTop: '16px' }}>
            <Paper style={{ width: '100%' }}>
                <Title title={'Dashboard do gestor'} />
                <Grid item xs={12}>
                    <Tabs value={val} onChange={handleTabChange} centered>
                        <Tab label={'Meus atendimentos'} key={'dashboard-processes'} />
                        <Tab label={'Minhas movimentações'} key={'dashboard-activities'} />
                        {context.profile.name !== ProfileEnum.GENERAL_LAWYER && <Tab label={'Correções'} key={'dashboard-pending-grade'} />}
                    </Tabs>
                </Grid>
                <Divider />
                <Panel value={val} index={0}>
                    <TeacherDashboardProcesses />
                </Panel>
                <Panel value={val} index={1}>
                    <TeacherDashboardActivities />
                </Panel>
                {context.profile.name !== ProfileEnum.GENERAL_LAWYER && <Panel value={val} index={2}>
                    <TeacherDashboardPendingGrades />
                </Panel>}
            </Paper>
            <TutorialDialog tutorialComplete={tutorialComplete} />
        </Grid >
    )
}

export default TeacherDashboard;